module.exports = __webpack_public_path__ + "fonts/616c4c87-a077-43f4-a9f4-f01267c13818.4aa75dfc.ttf";